import React from 'react';
import { main } from './InternalSectionTitle.module.css';

export default ({ children, ...props }) => (
    <h2 className={main} {...props}>{children}</h2>
);
